module.exports = __webpack_public_path__ + "static/media/4-6.6e3019c5.mp3";